import React, { useState, useEffect } from 'react';
import { store } from 'react-notifications-component';
import { IoMdClipboard } from 'react-icons/io';

import { PALE_WHITE_6 } from '../../appearance/Colors';

function CopyToClipboardNotification({ notificationId, title }) {
    const [progress, setProgress] = useState(100);
    const [timeLeft, setTimeLeft] = useState(10);

    useEffect(() => {
        var downloadTimer = setInterval(function () {
            if (timeLeft <= 0) {
                clearInterval(downloadTimer);
            }
            // document.getElementById('progressBar').value = 10 - timeleft;
            setTimeLeft(timeLeft - 1);

            setProgress(progress - 10);
        }, 1000);
        return () => {
            // cleanup
        };
    }, [timeLeft]);

    // if (progress > 0) {
    //     setTimeout(() => {
    //         setProgress(progress - 20);
    //     }, 10);
    // } else {
    //     setProgress(100);
    // }

    return (
        <div
            className="luckynote-toast luckynote-toast--clickable"
            onClick={() => {
                store.removeNotification(notificationId);
            }}
        >
            <div className="luckynote-toast__row">
                <div className="luckynote-toast__icon">
                    <IoMdClipboard color={PALE_WHITE_6} size={18}></IoMdClipboard>
                    {/* <ProgressRing radius={60} stroke={4} progress={progress} /> */}
                </div>
                <div className="luckynote-toast__body">
                    <div className="luckynote-toast__copy">
                        <div className="luckynote-toast__title">{title}</div>
                    </div>
                    <div className="luckynote-toast__spacer"></div>
                    {/* <div
                        style={{
                            justifyContent: 'center',
                            display: 'flex',
                            backgroundColor: PALE_WHITE_1,
                            padding: 4,
                            borderRadius: 4
                        }}
                    >
                        <FiX color={PALE_WHITE_6} size={16}></FiX>
                    </div> */}
                </div>
            </div>
        </div>
    );
}

export default CopyToClipboardNotification;
